module.exports = require('../../package.json').dependencies;